var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"issue-priority-table-cell"},[_c('img',{staticClass:"issue-priority-table-cell__image",attrs:{"src":_vm.getPriority}})])
}
var staticRenderFns = []

export { render, staticRenderFns }